import React, { AriaAttributes } from 'react';
import classnames from 'classnames';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import { useTranslation } from 'react-i18next';
import s from './AllButton.scss';

export interface Props {
  filterState?: string;
  size?: 'regular' | 'small';
  'aria-hidden'?: AriaAttributes['aria-hidden'];
}

const AllButton: React.FC<Props> = ({
  filterState,
  size,
  'aria-hidden': ariaHidden,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={classnames(s['root'], s[`size-${size}`])}
      aria-hidden={ariaHidden}
    >
      {filterState === 'subscribed' ? (
        <TierBadge size={size === 'small' ? 24 : 32} />
      ) : (
        <img
          src="https://st.deviantart.net/eclipse/global/svg/all-button.svg?1"
          width={24}
          height={20}
          alt={t('deviantsBar.button.all.dropdown.everyone.label')}
          className={s['everyone-icon']}
        />
      )}
    </div>
  );
};
AllButton.displayName = 'AllButton';

export default AllButton;
